export default __webpack_public_path__ + "static/media/about-banner.ab54a4ba.jpg";